module.exports = __webpack_public_path__ + "static/banner-478b1fcc707efa463d876e53a86ae532.jpg";